import React, { useCallback, useEffect } from 'react';
import Card from '../Card';
import { selectIsMyTurn, selectMyPlayer, buyTableCard, selectCardsInTable, selectHasAcceptedRoll } from '../../../redux/gameSlice';
import './BuyCardOverlay.scss';
import { useSelector, useDispatch } from 'react-redux';
import cardList from '../../../cardList';
import { selectOverlayBuyingCard, setOverlayBuyingCard } from '../../../redux/overlaySlice';
import { isPlayerBusinessMan } from '../../../playerUtils';
import { Trans } from '@lingui/macro';

export default function BuyCardOverlay(props) {
    const isMyTurn = useSelector(selectIsMyTurn);
    const cardsInTable = useSelector(selectCardsInTable);
    const myPlayer = useSelector(selectMyPlayer);
    const buyingCard = useSelector(selectOverlayBuyingCard);
    const hasAcceptedRoll = useSelector(selectHasAcceptedRoll);
    const dispatch = useDispatch();
    const cardType = cardsInTable[buyingCard];
    const costDiscount = isPlayerBusinessMan(myPlayer) ? 1 : 0;

    const clickOverlay = (ev) => {
        if (ev.target.id === "buy-card-overlay" || ev.target.id === "buy-card-container" || ev.target.classList.contains("fa-times")) {
            dispatch(setOverlayBuyingCard(null));
        }
    };

    const checkExitOverlay = useCallback((ev) => {
        ev.stopPropagation();
        // Check if hitting ESC
        if (ev.keyCode === 27) {
            dispatch(setOverlayBuyingCard(null));
        }
    }, [dispatch]);

    useEffect(() => {
        if (buyingCard === null) {
            return;
        }

        document.addEventListener("keydown", checkExitOverlay);
        return () => document.removeEventListener("keydown", checkExitOverlay)
    }, [buyingCard, checkExitOverlay]);

    const buyCard = useCallback((pos) => {
        if (!isMyTurn) {
            return;
        }

        dispatch(buyTableCard(Number(pos)));
    }, [dispatch, isMyTurn]);

    if (buyingCard === null) {
        return null;
    }

    let buttonContent = "";
    let buttonDisabled;
    if (!isMyTurn) {
        buttonContent = <Trans>WAIT FOR TURN</Trans>;
        buttonDisabled = true;
    } else if (!hasAcceptedRoll) {
        buttonContent = <Trans>ROLL DICE FIRST</Trans>;
        buttonDisabled = true;
    }
    else if (myPlayer.energy < (cardList[cardType].cost - costDiscount)) {
        buttonContent = <Trans>NOT ENOUGH ENERGY</Trans>;
        buttonDisabled = true;
    } else {
        buttonContent = <Trans>BUY CARD</Trans>;
        buttonDisabled = false;
    }
    return <div id="buy-card-overlay" className="esc-overlay noselect overlay-background dark-background-overlay" onClick={clickOverlay}>
        <i className="fas fa-times"></i>
        <div id="buy-card-container">
            <div id="buy-card-wrap">
                <Card type={cardType} costDiscount={costDiscount} />
                <button type="submit" className="button" id="buy-card-button" disabled={buttonDisabled} onClick={() => buyCard(buyingCard)}>
                    {buttonContent}
                </button>
            </div>
        </div>
    </div>;
}
